import type { ReactNode } from "react";
import { AtlasFinder } from "./AtlasFinder";
import { MarkytSidebar } from "./MarkytSidebar";
import { MarkytTopBar } from "./MarkytTopBar";

export function MarkytShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen bg-bg-2">
      <MarkytSidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <MarkytTopBar />
        <main className="flex-1 px-8 py-8">
          <div className="mx-auto max-w-6xl animate-mk-fade">{children}</div>
        </main>
      </div>
      <AtlasFinder />
    </div>
  );
}
